<!-- modal import -->
<div class="modal fade" id="{{idmodal}}" role="dialog" tabindex="-1">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{title}} - Import</h4>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container">

          <form>
            <!-- COMPONENT START -->
            <div class="form-group">
              <label class="control-label">File upload </label>
              <input type="file" class="filestyle" (change)="uploadFile($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" data-buttonText="Select a File">
            </div>
            <!-- COMPONENT END -->
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-color2 btn-right" data-bs-dismiss="modal">Close</button>
          <button type="button" id="buttonSubmitUpload" (click)="saveFile()" data-bs-dismiss="modal" class="btn btn-color2 btn-right" >Save</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- modal import end -->
